import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/ai-studio/event-creator')({
  validateSearch: (search) => ({
    fromListing: search.fromListing as string | undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/dashboard/events/create',
      search: { fromListing: search.fromListing },
      replace: true,
    })
  },
})
